var paragraph_default = {
  "fontElementMap": "G0S2u",
  "elementSpacing": "_2CUKx",
  "text": "H3kVU _2CUKx",
  "child": "_6GiMu"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
